import { Component, Inject, OnInit } from '@angular/core';
import { POPUP_DATA } from '../../../services/modal/modal.service';
import { MatButtonModule } from '@angular/material/button';

import { ModalService } from '../../../services/modal/modal.service';
import { PopUpComponent } from '../pop-up.component';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Overlay } from '@angular/cdk/overlay';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { Direction } from '@angular/cdk/bidi';
import { CLOSE, GENERAL_ERROR } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-error-message-pop-up',
    templateUrl: './error-message-pop-up.component.html',
    styleUrls: ['./error-message-pop-up.component.scss'],
    standalone: false
})
export class ErrorMessagePopUpComponent extends PopUpComponent implements OnInit {
  errorMessage: SafeHtml;
  closeText: string
  direction: Direction

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,
    @Inject(POPUP_DATA) public data: any,
    private readonly modalService: ModalService,
    private readonly languageService: LanguageService,
    private readonly sanitizer: DomSanitizer
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.closeText = CLOSE[language.language]
      const message = GENERAL_ERROR[language.language]
      this.errorMessage = this.formatErrorMessageWithPhoneLink(message)
    })
  }

  formatErrorMessageWithPhoneLink(message: string): SafeHtml {
    const phoneNumber = '*8787'
    const phoneLink = `<a href="tel:${phoneNumber}" dir="ltr" style="color: inherit; text-decoration: underline; cursor: pointer; display: inline-block;">${phoneNumber}</a>`
    const formattedMessage = message.replace(phoneNumber, phoneLink)
    return this.sanitizer.bypassSecurityTrustHtml(formattedMessage)
  }

  closePopup(): void {
    // Modal service handles the actual closing
    this.modalService.closePopUp();
  }
}
